import React, { Component } from "react";
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";

export default class PageFeaturedListings extends Component {
	
	constructor(){
		super()
		this.state = {
			open:false,
		}
		this.handleToggle = this.handleToggle.bind(this);
	}
	
	handleToggle = () => {
    	this.setState({ open: !this.state.open });
  	};
	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <>
			    	
			    	
				    	
		    		<div className="c-page__block c-page__block--no-space c-page__block--load-effect">
				
						<div className="l-content l-content--fixed-width">
	    				
	    					<div className="l-grid">
	    				
	    						<div className="l-grid__col">
	    						
	    							<div className="c-property-thumbs__header">
	    					
		    							<h4 className="c-heading" dangerouslySetInnerHTML={{__html:block.heading}}></h4>
								
										
										{block.menu &&
											
											<ul className="c-property-thumbs__menu">
												<li className="c-property-thumbs__menu__item">View</li>
												{block.menu.map((item,i) => 
													{
														return (
															<li className="c-property-thumbs__menu__item" key={i}>
																<Link to={item.url} className="c-property-thumbs__menu__link">{item.label}</Link>
															</li>
														)
													}
												)}
												
											</ul>
											
										}
										
									</div>
									
								</div>
								
							</div>
				
						</div>
						
					</div>
											
				
					<div className={'c-page__block c-page__block--' + block.space_after + ' c-page__block--load-effect'}>
						
						<div className="l-content l-content--fixed-width">
		    				
		    				<div className="l-grid">
		    				
		    					<div className="l-grid__col">
		    					
		    						<div className="c-property-thumbs">
		    							
		    							{block.listing.length === 0 &&
			    							<div className="c-property-thumbs__no-results">
			    								<div className="c-property-thumbs__no-results__inner">
			    									<h3 className="c-property-thumbs__no-results__heading">There are no matching properties</h3>
													<p className="c-property-thumbs__no-results__text">There are properties available that match the criteria you have selected. Please try expanding expanding your search.</p>
			    								</div>
			    							</div>
		    							}
		    							
		    							{block.listing.map((listing,i) => 
											{
												let thumbClass = 'c-property-thumbs__thumb'
												
												return (
				
													<div className={thumbClass}>
													
														<Link to={listing.url} className="c-property-thumbs__thumb__link">
															
															<div className="c-property-thumbs__thumb__image">
																
																{listing.srcset && 
																	<FadeIn>
																		{onload => (
																			<img
																				alt={""} 
																				src={listing.src} 
																				srcSet={listing.srcset} 
																				onLoad={onload}
																			/>
																		)}
																	</FadeIn>
																}
																{!listing.srcset && 
																	<FadeIn>
																		{onload => (
																			<img
																				alt={""} 
																				src={listing.src} 
																				onLoad={onload}
																			/>
																		)}
																	</FadeIn>
																}
																
															</div>
															
															<div className="c-property-thumbs__thumb__text">
															
																<div className={`c-property-thumbs__thumb__text__left ${listing.skistore ? "state-ski-store" : ""}`}>
																	<h3 className="c-paragraph" dangerouslySetInnerHTML={{__html:listing.heading}}></h3>
																	<h4 className="c-paragraph" dangerouslySetInnerHTML={{__html:listing.suburb}}></h4>
																</div>
																
																<div className={`c-property-thumbs__thumb__text__right ${listing.skistore ? "state-ski-store" : ""}`}>
																	
																	<ul className="c-icons c-icons--small">
																		
										    							{listing.bedrooms &&
											    							<li className="c-icons__item">
											    								<span className="c-icons__item__icon"><svg x="0px" y="0px" viewBox="0 0 29 26"><path d="M25.46,10.1V2.79c0-1.41-1.15-2.56-2.56-2.56H5.33c-1.41,0-2.56,1.15-2.56,2.56v7.31c-1.53,0.15-2.74,1.45-2.74,3.01v6.22 C0.01,19.39,0,19.45,0,19.51v5.55c0,0.39,0.32,0.71,0.71,0.71h2.24c0.39,0,0.71-0.32,0.71-0.71v-2.75h20.89v2.75 c0,0.39,0.32,0.71,0.71,0.71h2.25c0.39,0,0.71-0.32,0.71-0.71V13.11C28.23,11.53,27.01,10.23,25.46,10.1z M5.33,1.65H22.9 c0.62,0,1.13,0.51,1.14,1.14v7.3h-3.31V8.51c0-1.41-1.15-2.56-2.56-2.56h-8.1c0,0,0,0,0,0C8.65,5.95,7.5,7.1,7.5,8.51v1.58H4.19 l0-7.3C4.19,2.17,4.7,1.65,5.33,1.65z M19.3,8.51v1.58H8.93V8.51c0-0.63,0.51-1.14,1.14-1.14h8.1C18.79,7.37,19.3,7.88,19.3,8.51z M1.42,24.34V22.3h0.82l0,2.04H1.42z M26.81,24.34h-0.82V22.3h0.82V24.34z M26.81,20.88l-25.38,0v-0.66h25.38V20.88z M26.81,18.8 H1.45v-5.69c0-0.88,0.72-1.6,1.6-1.6h22.16c0.88,0,1.6,0.72,1.6,1.6V18.8z"/></svg></span>{listing.bedrooms}
											    							</li>
										    							}
										    							{listing.bathrooms &&
											    							<li className="c-icons__item">
											    								<span className="c-icons__item__icon"><svg x="0px" y="0px" viewBox="0 0 29 26"><path d="M26.75,13.98H3.03V2.34c0-0.3,0.25-0.54,0.55-0.54c0,0,0.01,0,0.01,0c0.24,0,0.45,0.17,0.52,0.39 C3.15,3.35,3.23,5.04,4.29,6.11l0.75,0.75c0.29,0.29,0.81,0.3,1.11,0l3.01-3.01c0.3-0.3,0.3-0.8,0-1.11L8.41,1.99 c-0.8-0.79-1.95-1.06-3-0.7C5.05,0.64,4.36,0.24,3.58,0.23v0H3.56v0c0,0,0,0,0,0c-0.28,0-0.55,0.06-0.81,0.17 c-0.78,0.33-1.28,1.1-1.28,1.95v12.43c0.01,3.55,2.18,6.79,5.44,8.17l-1.05,1.6c-0.25,0.35-0.17,0.84,0.19,1.09 c0.07,0.05,0.15,0.08,0.27,0.11l0,0.01c0.02,0,0.04,0,0.06,0.01c0,0,0,0,0,0h0c0.04,0.01,0.08,0.01,0.12,0.01 c0.06,0,0.12-0.01,0.17-0.02h0c0.19-0.04,0.36-0.15,0.5-0.35l1.29-1.98c0.62,0.13,1.25,0.2,1.88,0.2h8.33c0.63,0,1.26-0.07,1.88-0.2 l1.29,1.98c0.15,0.23,0.4,0.35,0.66,0.35c0.15,0,0.3-0.04,0.43-0.13c0.18-0.11,0.3-0.29,0.34-0.5c0.04-0.21,0-0.41-0.11-0.59 l-1.05-1.61c3.08-1.3,5.2-4.27,5.42-7.6l0.02,0.02v-0.6C27.53,14.33,27.18,13.98,26.75,13.98z M5.41,3.09L5.41,3.09 C5.66,2.84,6,2.7,6.35,2.7c0,0,0,0,0,0C6.69,2.7,7,2.82,7.24,3.03L7.51,3.3L5.6,5.2L5.4,5C5.15,4.74,5.01,4.4,5.01,4.04 S5.15,3.34,5.41,3.09z M18.66,22.06h-8.33c-3.72,0-6.86-2.85-7.26-6.52h22.85C25.52,19.22,22.39,22.06,18.66,22.06z"/></svg></span>{listing.bathrooms}
											    							</li>
										    							}
										    							{listing.parking &&
											    							<li className="c-icons__item">
											    								<span className="c-icons__item__icon"><svg x="0px" y="0px" viewBox="0 0 31 26"><path d="M30.84,9.03L30.84,9.03C30.84,9.03,30.84,9.03,30.84,9.03c0-1.27-1.04-2.31-2.32-2.31h-1.46l-1.24-3.22 c-0.53-1.19-1.54-2.12-2.81-2.54c-2.49-0.55-5.06-0.8-7.6-0.71c-0.64-0.02-1.29-0.02-1.92,0c-1.91,0.06-3.82,0.3-5.71,0.72 C6.55,1.38,5.54,2.31,5.01,3.51L3.78,6.72H2.32C1.04,6.72,0,7.76,0,9.03c0,1.16,0.86,2.12,2,2.29l-0.15,0.38 c-0.41,1.18-0.64,2.4-0.68,3.66v7.66c0,1.49,1.21,2.72,2.71,2.75l0,0l0.05,0l0.03,0h0c1.5-0.02,2.73-1.25,2.73-2.75v-0.48h17.45 v0.48c0,1.48,1.18,2.68,2.65,2.75l0.01,0.01h0.1v0c0,0,0,0,0,0c1.51-0.01,2.75-1.25,2.75-2.76v-7.66c-0.04-1.25-0.27-2.47-0.68-3.66 l-0.14-0.37c1.11-0.15,1.97-1.1,2-2.26l0,0l0-0.02L30.84,9.03z M28.52,9.95h-0.69c-0.09,0-0.17,0.02-0.25,0.05 c-0.36,0.14-0.54,0.54-0.4,0.9l0.5,1.29c0.35,1.02,0.55,2.09,0.59,3.17v7.65c0,0.75-0.61,1.36-1.36,1.36 c-0.75,0-1.36-0.61-1.36-1.36v-1.18c0-0.38-0.31-0.7-0.7-0.7H6l-0.5,0l0.1,0.13C5.42,21.4,5.3,21.6,5.3,21.84v1.18 c0,0.75-0.61,1.36-1.36,1.36c-0.75,0-1.36-0.61-1.36-1.36v-7.65c0.03-1.08,0.23-2.16,0.58-3.17l0.5-1.3 c0.03-0.08,0.04-0.16,0.05-0.25c0-0.38-0.31-0.7-0.7-0.7H2.32c-0.51,0-0.92-0.41-0.92-0.92s0.41-0.92,0.92-0.92h1.93c0,0,0,0,0,0 c0.29,0,0.55-0.18,0.65-0.45l1.4-3.64C6.67,3.22,7.36,2.59,8.16,2.3c2.38-0.52,4.82-0.74,7.26-0.67c2.44-0.07,4.88,0.15,7.22,0.66 c0.83,0.3,1.52,0.93,1.89,1.72l1.4,3.65c0.1,0.27,0.36,0.45,0.65,0.45h1.94c0,0,0,0,0,0c0.51,0,0.92,0.41,0.92,0.92 C29.44,9.54,29.03,9.95,28.52,9.95z M24.98,12.9c-0.62,0-1.2,0.24-1.64,0.68c-0.44,0.44-0.68,1.02-0.67,1.64 c0,1.27,1.04,2.31,2.32,2.31c0,0,0,0,0,0l0,0l0.01,0c1.27-0.01,2.3-1.04,2.3-2.32c0-0.62-0.24-1.2-0.68-1.64 C26.18,13.14,25.57,12.9,24.98,12.9z M24.98,16.13c-0.51,0-0.92-0.41-0.92-0.92s0.41-0.92,0.92-0.92c0.51,0,0.92,0.42,0.92,0.92 C25.9,15.72,25.49,16.13,24.98,16.13z M6.25,10.76c0.02,0,0.03,0,0.05,0h18.24c0.16,0.01,0.32-0.02,0.47-0.09 c0.27-0.11,0.47-0.32,0.58-0.59c0.11-0.27,0.1-0.56,0-0.81l-1.66-4.5c-0.24-0.59-0.8-0.98-1.44-1H8.34C7.71,3.79,7.14,4.18,6.9,4.78 L5.26,9.26C5.2,9.41,5.17,9.57,5.17,9.73c0.01,0.29,0.14,0.55,0.35,0.75C5.73,10.66,5.98,10.76,6.25,10.76z M8.21,5.28 c0.03-0.06,0.1-0.1,0.14-0.11l14.11,0c0.08,0.01,0.14,0.05,0.16,0.1l1.51,4.1H6.7L8.21,5.28z M5.85,12.9 c-1.28,0-2.32,1.04-2.32,2.32c0,1.28,1.04,2.32,2.32,2.32c1.27,0,2.31-1.04,2.32-2.32C8.17,13.94,7.13,12.9,5.85,12.9z M5.85,16.13 c-0.51,0-0.92-0.41-0.92-0.92c0-0.25,0.1-0.48,0.27-0.65c0.17-0.17,0.4-0.27,0.65-0.27c0,0,0,0,0,0c0.51,0,0.92,0.42,0.92,0.92 C6.77,15.72,6.36,16.13,5.85,16.13z"/></svg></span>{listing.parking}
											    							</li>
										    							}
										    							{listing.land &&
											    							<li className="c-icons__item">
											    								<span className="c-icons__item__icon"><svg x="0px" y="0px" viewBox="0 0 31 26"><path d="m11.05 12.97c1.51 2.22 2.88 4.53 4.12 6.92 0.17 0.33 0.57 0.47 0.9 0.31 0.13-0.07 0.24-0.17 0.31-0.31 1.24-2.38 2.62-4.69 4.12-6.92l0.25-0.38c1.16-1.79 2.19-3.57 2.11-5.71-0.03-0.81-0.19-1.6-0.48-2.35-1.43-3.65-5.54-5.45-9.19-4.03-1.85 0.72-3.3 2.18-4.03 4.03-0.28 0.74-0.44 1.53-0.47 2.34-0.08 2.14 0.95 3.92 2.11 5.71l0.25 0.39zm-1.01-6.05c0.03-0.66 0.16-1.31 0.39-1.93 1.16-2.95 4.5-4.4 7.46-3.24 1.48 0.58 2.65 1.76 3.24 3.24 0.23 0.62 0.36 1.27 0.39 1.93 0.07 1.74-0.86 3.33-1.89 4.93l-0.25 0.38c-1.23 1.9-2.5 3.85-3.59 5.88-1.09-2.03-2.36-3.98-3.59-5.88l-0.25-0.38c-1.05-1.6-1.97-3.18-1.91-4.93"/><path d="m15.78 11.48c2.42 0 4.39-1.97 4.39-4.39s-1.97-4.39-4.39-4.39-4.39 1.97-4.39 4.39 1.97 4.39 4.39 4.39m0-7.43c1.68 0 3.04 1.36 3.04 3.04s-1.36 3.04-3.04 3.04-3.04-1.36-3.04-3.04 1.36-3.04 3.04-3.04"/><path d="m30.13 26h-29.26c-0.37 0-0.68-0.3-0.68-0.68 0-0.1 0.02-0.19 0.06-0.28l5.75-12.44c0.16-0.34 0.56-0.49 0.9-0.33s0.49 0.56 0.33 0.9l-5.3 11.48h27.23l-4.38-11.52c-0.13-0.35 0.04-0.74 0.39-0.87s0.74 0.04 0.87 0.39l4.73 12.44c0.13 0.35-0.04 0.74-0.39 0.87-0.08 0.03-0.17 0.04-0.25 0.04"/></svg></span>{listing.land}
											    							</li>
										    							}
										    							{listing.building &&
											    							<li className="c-icons__item">
											    								<span className="c-icons__item__icon"><svg x="0px" y="0px" viewBox="0 0 32 26"><path d="M28.68,1.68H3.32C1.49,1.68,0,3.17,0,5v16c0,1.83,1.49,3.32,3.32,3.32h25.36c1.83,0,3.32-1.49,3.32-3.32V5 C32,3.17,30.51,1.68,28.68,1.68z M30.79,12.33H20v1.21h10.79V21c0,1.17-0.95,2.11-2.11,2.11H3.32c-1.17,0-2.11-0.95-2.11-2.11v-7.46 h10.08v5.96h1.21V6.37h-1.21v5.96H1.21V5c0-1.17,0.95-2.11,2.11-2.11h25.36c1.17,0,2.11,0.95,2.11,2.11V12.33z"/></svg></span>{listing.building}
											    							</li>
										    							}
										    							{listing.skistore &&
										    								<li className="c-icons__item">
											    								<span className="c-icons__item__icon"><svg x="0px" y="0px" viewBox="0 0 10 26"><path d="M2.13,0C0.95,0,0,0.95,0,2.13v21.74C0,25.05,0.95,26,2.13,26v0c1.18,0,2.13-0.95,2.13-2.13V2.13 C4.26,0.95,3.3,0,2.13,0z M3.04,23.87C3.04,23.87,3.04,23.87,3.04,23.87c0,0.5-0.41,0.91-0.91,0.91s-0.91-0.41-0.91-0.91V2.13 c0-0.5,0.41-0.91,0.91-0.91v0c0.5,0,0.91,0.41,0.91,0.91V23.87z M7.83,0C6.66,0,5.7,0.95,5.7,2.13v21.74C5.7,25.05,6.66,26,7.83,26 l0,0c1.18,0,2.13-0.95,2.13-2.13V2.13C9.96,0.95,9.01,0,7.83,0z M8.74,23.87C8.74,23.87,8.74,23.87,8.74,23.87 c0,0.51-0.41,0.91-0.91,0.91c-0.5,0-0.91-0.41-0.91-0.91V2.13c0-0.5,0.41-0.91,0.91-0.91v0c0.5,0,0.91,0.41,0.91,0.91V23.87z M2.36,10.74H1.9c-0.1,0-0.18,0.08-0.18,0.18v4.81c0,0.1,0.08,0.18,0.18,0.18h0.46c0.1,0,0.18-0.08,0.18-0.18v-4.81 C2.54,10.82,2.46,10.74,2.36,10.74z M8.06,10.74H7.6c-0.1,0-0.18,0.08-0.18,0.18v4.81c0,0.1,0.08,0.18,0.18,0.18h0.46 c0.1,0,0.18-0.08,0.18-0.18v-4.81C8.24,10.82,8.16,10.74,8.06,10.74z"/></svg></span>Ski Store
											    							</li>
										    							}
										    						</ul>
										    						
										    						{listing.categories &&
										    						
										    							<p className="c-paragraph c-paragraph--faded" dangerouslySetInnerHTML={{__html:listing.categories}}></p>
										    						
										    						}
										    					
				    						
																</div>
																
																{listing.sold &&
																	<p className="c-property-thumbs__thumb__banner" dangerouslySetInnerHTML={{__html:'Sold'}}></p>
																}
																
																{listing.under_offer &&
																	<p className="c-property-thumbs__thumb__banner" dangerouslySetInnerHTML={{__html:'Under Offer'}}></p>
																}
																
															</div>
															
														</Link>
													
													</div>
												
												)
											}
										)}
		    						
		    						</div>
		    						
		    					</div>
		    					
		    				</div>
		    		
						</div>
		    		
		    		</div>
		    				
		    	</>
			    
			)
			
		} else {
			
			return null;
		
		}
	}
}
